import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DynamicTable from "../../../components/Comman/RT/MaterialUIRTTable";
import { challanProductDetailColumns } from "../../../tableColumns/table-columns";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
        ) : null}
    </DialogTitle>
);

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const PopUpProductDetails = ({ handleClose, open, rows, productName }) => (
    <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="product-details-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
    >
        <BootstrapDialogTitle
            id="product-details-dialog-title"
            onClose={handleClose}
        >
            Product Details{productName ? ` — ${productName}` : ""}
        </BootstrapDialogTitle>
        <DialogContent dividers>
            <DynamicTable
                data={rows}
                tableHead={challanProductDetailColumns}
                showPegination={false}
                isActionColActive={false}
                // showSearchBoxForTable={false}
            />
            <br />
        </DialogContent>
    </BootstrapDialog>
);

PopUpProductDetails.propTypes = {
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    rows: PropTypes.array,
    productName: PropTypes.string,
};

PopUpProductDetails.defaultProps = {
    rows: [],
    productName: "",
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PopUpProductDetails);
